// this file is generated by update_shopify_store_data.py at 2026-02-23 20:30:55.745227
var courses = [];